import {
  Box,
  Button,
  Dialog,
  DialogProps,
  FormControl,
  FormControlLabel,
  MenuItem,
  OutlinedInput,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Theme,
  useTheme,
} from "@mui/material";
import React, { ChangeEvent, useCallback, useState } from "react";
import Radio from "@mui/material/Radio";
// import styles from "@/styles/components/filterModal.module.scss";
import assest from "../../json/assest";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import {
  setAgreementWithAnotherCompany,
  setDuplicates,
  setHasNote,
  setInquirerKey,
  setInquirerValue,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setUnreachableSubmitter,
  setUserId,
} from "../../redux-toolkit/slices/submitted.inquiring.slice";
import { useAppSelector } from "../../hooks/useAppSelector";
// import assest from "@/json/assest";
import styles from "../../styles/pages/superadmin/submittedvideoModals/inquering.module.scss";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      "& .MuiList-root": {
        "& .MuiMenuItem-root": {
          fontWeight: "500",
          fontSize: "11px",
          color: "#525050",
        },
      },
    },
  },
};

// const names = [
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
//   "Lorem Ipsum",
// ];

// function getStyles(name, personName, theme) {
//   return {
//     fontWeight:
//       personName.indexOf(name) === -1
//         ? theme.typography.fontWeightRegular
//         : theme.typography.fontWeightMedium,
//   };
// }
// export type FilterModalProps = DialogProps & {
//     hideBottom?: boolean;
//     modalFields:
//         | {
//               has_note: string;
//               unreachable_submitter: string;
//               people_appearing: string;
//               person_who_filmed: string;
//               submit_other_website: string;
//               aggrement_with_another_company: string;
//           }
//         | any;
//     handleFilterParamChange: (event: ChangeEvent<HTMLInputElement>) => void;
//     resetFilterparams: () => void;
//     handleFilterSelect: () => void;
// };

const SubmittedInquiringFilterModal = (props) => {
  const {
    user_id,
    duplicates,
    has_note,
    unreachable_submitter,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    // inquirer_key,
    inquirer_value,
  } = useAppSelector((s) => s.inquiringSubmittedSlice);

  const { acquisitors, inquirers } = useAppSelector((s) => s.appStateSlice);
  // console.warn("inquirers", inquirers);

  // console.warn("acquisitors", acquisitors);
  // console.warn('month', month)

  const { hideBottom, onClose, modalFields, ...rest } = props;
  const dispatch = useAppDispatch();
  // const theme = useTheme();
  // const [personName, setPersonName] = React.useState([]);
  //console.warn(hideBottom,"hideBottom");
  //   console.warn('props.filterRefetch', props)
  //   console.warn('filterRowProps modal', filterRowProps);

  // const handleChange = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setPersonName(
  //     // On autofill we get a stringified value.
  //     typeof value === "string" ? value.split(",") : value
  //   );
  // };

  const handleClose = useCallback(
    (e, reason) => {
      onClose?.(e, reason || "backdropClick");
    },
    [onClose]
  );

  //   console.warn(personName);
  const [mockUser, setMockUser] = useState();
  const [mockInquirer, setMockInquirer] = useState();
  // console.warn("props?.handleCloseFilterModal", props);

  return (
    <Dialog className="filterModal" {...rest} onClose={handleClose}>
      <Box className="filterModalWrapper">
        <Box className="filterModalHeader">
          <h4>Filter</h4>
          <Button onClick={props?.handleClearFilterModal}>
            <img src={assest.resetIcon} width={9} height={9} alt="" />
            <p>Clear</p>
          </Button>
        </Box>

        <Box className="filterModalBody">
          <Box className="filterBodyBox">
            <Box className={styles.pendingModalTop}>
              <Box className={`filterBoxItem ${styles.acqui}`}>
                <label>
                  Inquirers{" "}
                  <img
                    onClick={() => {
                      dispatch(setInquirerKey(null));
                      dispatch(setInquirerValue(null));
                    }}
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect">
                  <Select
                    labelId="user-label"
                    id="user-select"
                    displayEmpty
                    value={inquirer_value}
                    renderValue={() => {
                      // console.warn('selected', selected)
                      if (!inquirer_value) {
                        return <span>Inquirers</span>;
                      } else {
                        return <span>{mockInquirer.name}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setInquirerValue(e.target.value.id));
                      dispatch(
                        setInquirerKey(e.target.value.role.name + "_id")
                      );
                      setMockInquirer(e.target.value);
                      // console.warn("e.target.value", e.target.value);
                    }}
                  >
                    {inquirers?.map((a, i) => (
                      <MenuItem key={i} value={a}>
                        {a.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>

              <Box className={`filterBoxItem ${styles.acqui}`}>
                <label>
                  Acquisitor{" "}
                  <img
                    onClick={() => dispatch(setUserId(null))}
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                <Box className="filterSelect">
                  <Select
                    labelId="user-label"
                    id="user-select"
                    displayEmpty
                    value={user_id}
                    renderValue={() => {
                      // console.warn('selected', selected)
                      if (!user_id) {
                        return <span>Acquisitor</span>;
                      } else {
                        return <span>{mockUser.name}</span>;
                      }
                    }}
                    MenuProps={MenuProps}
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    onChange={(e) => {
                      dispatch(setUserId(e.target.value.id));
                      setMockUser(e.target.value);
                      // console.warn("e.target.value", e.target.value);
                    }}
                  >
                    {acquisitors?.map((a, i) => (
                      <MenuItem key={i} value={a}>
                        {a.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>

              <Box className={`filterBoxItem ${styles.hasNote}`}>
                <label>
                  Has Notes?{" "}
                  <img
                    src={assest.resetIconBlue}
                    width={9}
                    onClick={() => dispatch(setHasNote(null))}
                    height={9}
                    alt=""
                  />
                </label>
                {/* <Box className="filterRadio">
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </Box> */}
                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue={null}
                      value={has_note != null ? has_note : null}
                      name="has_note"
                      onChange={(e) => dispatch(setHasNote(e.target.value))}
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                          // onClick={() => dispatch(setHasNote("yes"))}
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                          // onClick={() => dispatch(setHasNote("no"))}
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className={`filterBoxItem ${styles.potential}`}>
                <label>
                  Show potential duplicates only?{" "}
                  <img
                    onClick={() => dispatch(setDuplicates(null))}
                    src={assest.resetIconBlue}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                {/* <Box className="filterRadio">
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </Box> */}
                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      name="duplicates"
                      value={duplicates != null ? duplicates : null}
                      onChange={(e) => dispatch(setDuplicates(e.target.value))}

                      /* onChange={
                                            props?.handleFilterParamChange
                                        } */
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>

              <Box className={`filterBoxItem ${styles.unreachAble}`}>
                <label>
                  Unreachable Submitter?{" "}
                  <img
                    src={assest.resetIconBlue}
                    onClick={() => dispatch(setUnreachableSubmitter(null))}
                    width={9}
                    height={9}
                    alt=""
                  />
                </label>
                {/* <Box className="filterRadio">
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </Box> */}
                <Box className="filterRadio">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue="female"
                      value={unreachable_submitter}
                      name="unreachable_submitter"
                      onChange={(e) =>
                        dispatch(setUnreachableSubmitter(e.target.value))
                      }
                    >
                      <Box className="filterFromControl">
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
            </Box>
            {hideBottom === true ? (
              <Box className="filterBodyBox filterBodyBox2">
                <Box className="filterBoxItem">
                  <label>
                    Are There People Appearing In The Video?{" "}
                    <img
                      src={assest.resetIconBlue}
                      width={9}
                      height={9}
                      alt=""
                      onClick={() => dispatch(setPeopleAppearing(null))}
                    />
                  </label>
                  {/* <Box className="filterRadio">
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </Box> */}

                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        value={people_appearing}
                        name="people_appearing"
                        onChange={(e) =>
                          dispatch(setPeopleAppearing(e.target.value))
                        }
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="yes"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            value="no"
                            control={<Radio />}
                            label="No"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>

                <Box className="filterBoxItem">
                  <label>
                    The Person Who Filmed This Video Is:{" "}
                    <img
                      src={assest.resetIconBlue}
                      onClick={() => dispatch(setPersonWhoFilmed(null))}
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>
                  {/* <Box className="filterRadio">
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Me"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="A Family Member"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="A Friend"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Someone I Know"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="A Dashcam"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="A Security Camera"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio />}
                    label="Other: the kid of my friend"
                  />
                </Box> */}

                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        // value={props?.modalFields?.person_who_filmed}
                        value={
                          person_who_filmed != null ? person_who_filmed : null
                        }
                        name="person_who_filmed"
                        // onChange={props?.handleFilterParamChange}
                        onChange={(e) =>
                          dispatch(setPersonWhoFilmed(e.target.value))
                        }
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="Me"
                            control={<Radio />}
                            label="Me"
                          />
                          <FormControlLabel
                            value="A Family Member"
                            control={<Radio />}
                            label="A Family Member"
                          />
                          <FormControlLabel
                            value="A Friend"
                            control={<Radio />}
                            label="A Friend"
                          />
                          <FormControlLabel
                            value="Someone I Know"
                            control={<Radio />}
                            label="Someone I Know"
                          />
                          <FormControlLabel
                            value="A Dashcam"
                            control={<Radio />}
                            label="A Dashcam"
                          />
                          <FormControlLabel
                            value="A Security Camera"
                            control={<Radio />}
                            label="A Security Camera"
                          />
                          <FormControlLabel
                            value="Other: the kid of my friend"
                            control={<Radio />}
                            label="Other: the kid of my friend"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>

                <Box className="filterBoxItem">
                  <label>
                    Did You Send/Submit/Upload This Video To A Website And/Or
                    Social Media Account?{" "}
                    <img
                      src={assest.resetIconBlue}
                      onClick={() => dispatch(setSubmitOtherWebsite(null))}
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>

                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        value={
                          submit_other_website != null
                            ? submit_other_website
                            : null
                        }
                        // value={props?.modalFields?.submit_other_website}
                        name="submit_other_website"
                        // onChange={props?.handleFilterParamChange}
                        onChange={(e) =>
                          dispatch(setSubmitOtherWebsite(e.target.value))
                        }
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="No, I Did Not"
                            control={<Radio />}
                            label="No, I Did Not"
                          />
                          <FormControlLabel
                            value="Yes, Another Company's Website"
                            control={<Radio />}
                            label="Yes, Another Company's Website"
                          />
                          <FormControlLabel
                            value="Yes, A Facebook Page"
                            control={<Radio />}
                            label="Yes, A Facebook Page"
                          />
                          <FormControlLabel
                            value="Yes, A Twitter Account"
                            control={<Radio />}
                            label="Yes, A Twitter Account"
                          />
                          <FormControlLabel
                            value="Yes, An Instagram Account"
                            control={<Radio />}
                            label="Yes, An Instagram Account"
                          />
                          <FormControlLabel
                            value="Yes, A YouTube Channel"
                            control={<Radio />}
                            label="Yes, A YouTube Channel"
                          />
                          <FormControlLabel
                            value="Yes, A Snaphat Account"
                            control={<Radio />}
                            label="Yes, A Snaphat Account"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>

                <Box className="filterBoxItem">
                  <label>
                    Did You Sign A Licensing Agreement For This Video With
                    Another Company/Page?{" "}
                    <img
                      src={assest.resetIconBlue}
                      onClick={() =>
                        dispatch(setAgreementWithAnotherCompany(null))
                      }
                      width={9}
                      height={9}
                      alt=""
                    />
                  </label>

                  <Box className="filterRadio">
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue="female"
                        value={
                          aggrement_with_another_company != null
                            ? aggrement_with_another_company
                            : null
                        }
                        // value={
                        //   props?.modalFields?.aggrement_with_another_company
                        // }
                        name="aggrement_with_another_company"
                        // onChange={props?.handleFilterParamChange}
                        onChange={(e) =>
                          dispatch(
                            setAgreementWithAnotherCompany(e.target.value)
                          )
                        }
                      >
                        <Box className="filterFromControl">
                          <FormControlLabel
                            value="No, I Did Not"
                            control={<Radio />}
                            label="No, I Did Not"
                          />
                          <FormControlLabel
                            value="Yes, I Have Filled An Online Not"
                            control={<Radio />}
                            label="Yes, I Have Filled An Online Not"
                          />
                          <FormControlLabel
                            value="Yes, I Have Signed An Exclusive Agreement"
                            control={<Radio />}
                            label="Yes, I Have Signed An Exclusive Agreement"
                          />
                          <FormControlLabel
                            value="Yes, I Have Signed A Non-Exclusive Agreement"
                            control={<Radio />}
                            label="Yes, I Have Signed A Non-Exclusive Agreement"
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Box>
              </Box>
            ) : null}
          </Box>
        </Box>

        <Box className="filterModalFooter">
          <Box className="buttonGroup">
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              className="activeButton"
              type="submit"
              onClick={props?.filterRefetch}
            >
              Filter now
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SubmittedInquiringFilterModal;
